import React from 'react';

export default function SimpleLoading() {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#00000091',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#FFF',
        fontSize: 24,
        fontWeight: 800,
        zIndex: 999
      }}
    >
      Loading...
    </div>
  );
}
